import React, { Component } from "react";
import { injectIntl, IntlShape } from "@ai360/core/intl";

import { withCrud } from "~/hocs";
import { DataTable } from "~/core";
import { FormattingHelpers } from "@ai360/core";
import { memoizeFormattedRecords } from "~/admin/utils";

import { service, actions } from "./log-data";
import { messages } from "../../agBytes/i18n-messages";

interface INutrientRemovalRateLogProps {
    records?: Record<string, unknown>[];
    intl: IntlShape;
}

export class NutrientRemovalRateLog_ extends Component<INutrientRemovalRateLogProps> {
    getFormattedRecords = memoizeFormattedRecords(FormattingHelpers.formatLogDetailText);
    render(): JSX.Element {
        return (
            <div>
                <DataTable
                    service={service}
                    isCheckbox={false}
                    showFilterInput={false}
                    messages={messages}
                    {...this.props}
                    records={this.getFormattedRecords(this.props.records)}
                />
            </div>
        );
    }
}
export const NutrientRemovalRateLog = injectIntl(
    withCrud(NutrientRemovalRateLog_, service, actions)
);
